<template>
      <iframe 
        :src="iframe.src"
        :style="iframe.style"
        :height="iframe.style.height"
        :width="iframe.style.width"
        frameborder="0"
      ></iframe>

</template>
<script>
import JqxLoader from "jqwidgets-scripts/jqwidgets-vue/vue_jqxloader.vue";

import { BiApiService } from "@/api/BiApiService";
import { Util } from "@/api/Util";
const biApiService = new BiApiService();
const util = new Util();


export default {
  components: {
    JqxLoader
  },
  data() {
    return {
      loaded: false,
      iframe: {
        src: "",
        style: null,
        wrapperStyle: null,
      }
    }
  },
  created() {
    this.iframe.src="http://172.20.120.122:8082/#/home";
    this.iframe.style = {
      position: 'absolute',
      width: window.innerWidth-61,
      height: window.innerHeight-47,
    }    
    this.iframe.wrapperStyle = {
      overflow: 'hidden',
    } 
  }
}
</script>
